(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('event-status', {
            parent: 'entity',
            url: '/event-status?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.eventStatus.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-status/event-statuses.html',
                    controller: 'EventStatusController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('event-status-detail', {
            parent: 'entity',
            url: '/event-status/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.eventStatus.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-status/event-status-detail.html',
                    controller: 'EventStatusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EventStatus', function($stateParams, EventStatus) {
                    return EventStatus.get({id : $stateParams.id});
                }]
            }
        })
        .state('event-status.new', {
            parent: 'event-status',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-status/event-status-dialog.html',
                    controller: 'EventStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('event-status', null, { reload: true });
                }, function() {
                    $state.go('event-status');
                });
            }]
        })
        .state('event-status.edit', {
            parent: 'event-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-status/event-status-dialog.html',
                    controller: 'EventStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventStatus', function(EventStatus) {
                            return EventStatus.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-status', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('event-status.delete', {
            parent: 'event-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-status/event-status-delete-dialog.html',
                    controller: 'EventStatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EventStatus', function(EventStatus) {
                            return EventStatus.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-status', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
